import React from "react";
import { ExternalLink } from "components/ExternalLink";
import {
  CopyableCodeLine,
  InlineCode,
} from "onboarding/components/NumberedStep";
import { KB_URL_BASE } from "onboarding/constants";
import { track } from "utils/track";

const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/ruby/install/`;

const rubyInstructions = props => {
  const { agentRecorderToken, serviceName } = props;
  return [
    {
      precedingContent: (
        <div>
          The Ruby agent is provided as a gem called `appoptics_apm`. Once
          installed, you&apos;ll just need to set the service key and require
          the gem in your application. See the quick instructions below for
          Rails, or{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation
          </ExternalLink>{" "}
          for more details.
        </div>
      ),
      title: "Install and enable the Ruby agent.",
      content: (
        <div onClick={_ => track("Copied the Ruby APM gem name")}>
          Rails will load the <InlineCode>appoptics_apm</InlineCode> gem and do
          instrumentation automatically if{" "}
          <InlineCode>gem &apos;appoptics_apm&apos;</InlineCode> is added at the
          end of your application&apos;s Gemfile.
          <CopyableCodeLine>{"gem 'appoptics_apm'"}</CopyableCodeLine>
        </div>
      ),
    },
    {
      title:
        "The service key is provided via an environment variable. Make sure this is available in the environment where your application is running:",
      content: (
        <div onClick={_ => track("Copied the Ruby APM service key")}>
          <CopyableCodeLine shell>
            export APPOPTICS_SERVICE_KEY={agentRecorderToken}:{serviceName}
          </CopyableCodeLine>
          <p>
            Using another framework?{" "}
            <ExternalLink href={KNOWLEDGEBASE_URL}>
              Check out the docs
            </ExternalLink>{" "}
            for instructions on Sinatra and other frameworks.
          </p>
          <p>
            A few seconds after you restart your application, the agent will be
            connected to AppOptics.
          </p>
        </div>
      ),
    },
  ];
};

export default rubyInstructions;
